import { render, staticRenderFns } from "./ModalInserirOcorrencia.vue?vue&type=template&id=54c5ed93&scoped=true"
import script from "./ModalInserirOcorrencia.vue?vue&type=script&lang=js"
export * from "./ModalInserirOcorrencia.vue?vue&type=script&lang=js"
import style0 from "./ModalInserirOcorrencia.vue?vue&type=style&index=0&id=54c5ed93&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c5ed93",
  null
  
)

export default component.exports